import React, { Suspense, lazy } from 'react'

const DatePickerInner = lazy(() =>
    Promise.all([
        import('react-datepicker'),
        import('react-datepicker/dist/react-datepicker.css'),
    ]).then(([module]) => ({ default: module.default })),
)

export default function DatePicker(props) {
    return (
        <Suspense fallback={null}>
            <DatePickerInner {...props} />
        </Suspense>
    )
}
